import { css } from '@emotion/react';

import { getLatestProgressStatus, ScanTaskOptimized } from '@kaiizen/kai-scan-template-system';

import { taskNamePresenter } from '@kaiizen/kai-presenters';
import { useNavigateToScan } from '../../../State/kaiNavigation';
import { COLORS2, LAYOUT2 } from '../../../Styles';
import { ScanNavigatorItem } from '../ScanNavigator/ScanNavigatorItem';
import { TaskIcons } from './WorkStatusIcons';

const TASK_PROGRESS_ITEM_STYLE = css`
  label: TASK_PROGRESS_ITEM_STYLE;
  display: flex;
  align-items: center;
  gap: ${LAYOUT2.spacing1}px;
  color: ${COLORS2.alwaysDark.text.white};
`;

export const ProgressScanNavigatorTaskItem = ({
  scanId,
  groupId,
  task,
  isCurrentTask,
}: {
  scanId: string;
  groupId: string;
  task: ScanTaskOptimized;
  isCurrentTask?: boolean;
}) => {
  const navigateToScan = useNavigateToScan();
  const onSelect = () => navigateToScan({ scanId, groupId, taskId: task.id, progress: true });

  return (
    <ScanNavigatorItem isSelected={isCurrentTask} onSelect={onSelect}>
      <div css={TASK_PROGRESS_ITEM_STYLE}>
        <TaskIcons workStatus={getLatestProgressStatus(task) ?? 'notStarted'} />
        {taskNamePresenter(task)}
      </div>
    </ScanNavigatorItem>
  );
};
